import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ModelFirmwarePageComponent } from './model-firmware-page.component';

const routes: Routes = [
  {
    path: 'model-firmware',
    data: { name: 'View/Create/Update Device Model', isTab: false },
    component: ModelFirmwarePageComponent,
  },
  { path: 'model-firmware/:id', component: ModelFirmwarePageComponent },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModelFirmwarePageRoutingModule {}
